import { InventoryData, TInventory, TransactionDetail, logisticOptions } from "../../Models/Inventory"
import useService from "../../hooks/useService"
import { createStockTransferOrder } from "../../services/Inventory"
import { genId } from "../../utils/helpers"
import DynamicForm, { TField, useDynamicForm } from "../forms/DynamicFormNew"


type TInventoryTransfer = {
    logisticAgencyName: string
    awbNumber?: string
    remarks: string
}
const INVENTORY_TRANSFER_FORM: TField<TInventoryTransfer>[] = [
    {
        fieldName: 'logisticAgencyName',
        isVisible: true,
        fieldType: 'select',
        label: 'Logistic Agency Name',
        fullWidth: false,
        options: logisticOptions,
        validation: {
            required: true
        }
    },
    {
        fieldName: 'awbNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'AWB Number',
        fullWidth: false,
        // validation: {
        //     required: true
        // }
    },
    {
        fieldName: 'remarks',
        isVisible: true,
        fieldType: 'text',
        label: 'Remarks',
        fullWidth: false,
        validation: {
            required: true
        }
    },
]

const TransferMetal = ({ onSuccess }: { onSuccess: () => any }) => {
    const { registerForm } = useDynamicForm({ formConfig: INVENTORY_TRANSFER_FORM })
    const { execute, store: { transactionsStore, notificationStore } } = useService()
    const { jobworkInventory, transactionInfo, setJobworkInventory, inboundDetails } = transactionsStore
    const { notify } = notificationStore
    const { globalTransactionNumber } = transactionInfo

    const submitHandler = async (data: TInventoryTransfer) => {
        const { awbNumber, logisticAgencyName, remarks } = data

        
        const { error } = await execute(() => createStockTransferOrder({
            inventoryLineItems: [
                {
                    ...jobworkInventory,
                    transactionDetails: {
                        globalTransactionNumber: transactionInfo.globalTransactionNumber!,
                        inboundId: inboundDetails.id,
                        centreId: transactionInfo.pvcCenterId,
                        createdAt: transactionInfo.createdAt as unknown as string,
                        currency: transactionInfo.currency,
                        customerRefNo: transactionInfo.customerId,
                        remarks: transactionInfo.remarks,
                        secondaryTransactionLocation: transactionInfo.secondaryTransactionLocationId,
                        status: transactionInfo.status,
                        transactionType: transactionInfo.transactionType,
                        updatedAt: transactionInfo.updatedAt as unknown as string,
                        weightUOM: transactionInfo.weightUOM
                    } as TransactionDetail,
                    transferredWeight: jobworkInventory.currentWeight,
                    unitWeight: jobworkInventory.currentWeight,
                    remarks: '',
                    fineWeightChange: jobworkInventory.currentFineWeight
                } as InventoryData],
            remarks: remarks,
            destination_id: '',
            gross_rate: 0,
            invoice_grand_total: 0,
            // mts_delivery_challan_code: 'sample' + genId(),
            // is_mts_transfer: false,
            // is_mts_updated: false,
            // mts_transfer_type: '',
            shipper_id: '',
            status: '',
            total_gold_fine_weight: jobworkInventory.currentFineWeight,
            total_silver_fine_weight: 0,
            acknowledged_at: '',
            acknowledgement_remarks: '',
            created_by: '',
            awb_number: awbNumber,
            logistic_agency_name: logisticAgencyName
        }))

        if (error === null) {
            notify('Metal transferred to plant Successfully')
            onSuccess()
            setJobworkInventory({}  as TInventory)
        }
    }

    return <div>
        <DynamicForm
            {...registerForm()}
            onSubmit={submitHandler}
            submitText='Transfer Metal To Plant'
        />
    </div>
}

export default TransferMetal